
import { DatePipe, formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api-services/api.service';
import { viewUser } from 'app/meta.service';
import moment from 'moment';

@Component({
  selector: 'app-view-add-on-types',
  templateUrl: './view-add-on-types.component.html',
  styleUrls: ['./view-add-on-types.component.scss']
})


export class ViewAddOnTypesComponent {
  AddOnplans = [];
  planBenefits=[];
  planDuration=[];
 
  reportToUserNames = [];
 
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public apiService: ApiService, private datePipe: DatePipe
  ) { }
  ngOnInit() {
    this.getUserById();
  }
  getUserById() {
    this.AddOnplans = this.data.data;
    this.AddOnplans.forEach(element => {
      this.planBenefits = element.all_benefits_points;

    });
  }
}



